import React from 'react';
import { FormattedMessage } from 'react-intl';
import { hasNonGenericRepName } from 'dibs-workspace-intro-modal/exports/ContactVipRepHelper';

export const deliveryTitle = (
    <FormattedMessage id="pdpBlurb.deliveryTitle" defaultMessage="Shipping: " />
);

export const freeShippingTitle = (
    <FormattedMessage id="pdpBlurb.freeShippingTitle" defaultMessage="Free Shipping" />
);

export const freeWhiteGloveShippingTitle = (
    <FormattedMessage
        id="pdpBlurb.freeWhiteGloveShippingTitle"
        defaultMessage="Free White Glove Shipping"
    />
);

export const whiteGloveShippingTitle = price => (
    <FormattedMessage
        id="pdpBlurb.whiteGloveShippingTitle"
        defaultMessage="{price} White Glove Shipping"
        values={{ price }}
    />
);

export const leadTimeTitle = (
    <FormattedMessage id="pdpBlurb.leadTimeTitle" defaultMessage="Estimated Production Time:" />
);

export const buyerProtectionTitle = (
    <FormattedMessage
        id="pdpBlurb.buyerProtectionTitle"
        defaultMessage={'Buyer Protection Guarantee'}
    />
);

export const buyerProtectionText = (
    <FormattedMessage
        id="pdpBlurb.buyerProtectionText"
        defaultMessage={`If your purchase doesn't arrive as described, 1stdibs will make it right.`}
    />
);

export const pcsTitle = (
    <FormattedMessage id="pdpBlurb.pcsTitle" defaultMessage="Need Assistance?" />
);
export const pcsText = name => (
    <FormattedMessage
        id="pdpBlurb.pcsText"
        defaultMessage={`
            {hasName, select,
                true {Your specialist can help.}
                false {We can help.}
            }
        `}
        values={{ name, hasName: hasNonGenericRepName(name) }}
    />
);

export const pcsTitleSoldPdp = (
    <FormattedMessage id="pdpBlurb.pcsTitleSoldPdp" defaultMessage="Want something similar?" />
);

export const pcsTextSoldPdp = name => (
    <FormattedMessage
        id="pdpBlurb.pcsTextSoldPdp"
        defaultMessage={`
            {hasName, select,
                true {Your specialist can find it.}
                false {We can find it.}
            }
        `}
        values={{ name, hasName: hasNonGenericRepName(name) }}
    />
);

export const pcsTextSoldPdpBanner = name => (
    <FormattedMessage
        id="pdpBlurb.pcsTextSoldPdpBanner"
        defaultMessage={`Contact
            {hasName, select,
                true {your}
                false {a}
            } Private Client specialist{hasName, select,
                true {, {name},}
                false {}
            } for help finding something similar.
        `}
        values={{ name, hasName: hasNonGenericRepName(name) }}
    />
);

export const messageCta = name => (
    <FormattedMessage
        id="pdpBlurb.messageCta"
        defaultMessage={`Message 
            {hasName, select,
                true {{name}}
                false {a specialist}
            }
        `}
        values={{ name, hasName: hasNonGenericRepName(name) }}
    />
);

export const returnsTitle = (
    <FormattedMessage id="pdpBlurb.returnsTitle" defaultMessage="Worry-Free Returns" />
);
export const returnsText = returnPolicyLength => (
    <FormattedMessage
        id="pdpBlurb.returnsText"
        defaultMessage={`This piece can be returned within {returnPolicyLength, number} {returnPolicyLength, plural,
            one {day}
            other {days}
        }.`}
        values={{ returnPolicyLength }}
    />
);
export const returnsCta = (
    <FormattedMessage id="pdpBlurb.returnsCta" defaultMessage="View Returns Details" />
);

export const shipsFrom = (
    <FormattedMessage
        id="pdp.PdpSharedBlurbShippingCustomQuote.requestQuoteOverviewShipsFrom"
        defaultMessage="Ships From: "
    />
);

export const shipsFromLocation = itemLocation => (
    <FormattedMessage
        id="pdp.PdpSharedBlurbShippingCustomQuote.requestQuoteOverviewShipsFromLocation"
        defaultMessage="{itemLocation}"
        values={{ itemLocation }}
    />
);

export const supportNumberTitle = (
    <FormattedMessage id="pdp.PdpSharedBlurbSupportNumber.blurbTitle" defaultMessage="Need help?" />
);

export const supportNumberText = supportNumber => (
    <FormattedMessage
        id="pdp.PdpSharedBlurbSupportNumber.blurbText"
        defaultMessage="Call our 1stdibs specialists {supportNumber}"
        values={{ supportNumber }}
    />
);
